import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65b85751"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tir-pm-video-player-title" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tir-pm-video-player-title_background" }, null, -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-video-player-title',
  props: {
  /**Имя видеозаписи */
  name: { type: String, default: '' },
},
  setup(__props) {

/**Параметры */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      textContent: _toDisplayString(__props.name),
      class: "tir-pm-video-player-title_text"
    }, null, 8, _hoisted_2),
    _hoisted_3
  ]))
}
}

})